// react
import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
// application
import { connect } from 'react-redux';
import FooterContacts from './FooterContacts';
import FooterLinks from './FooterLinks';
// import FooterLinksTwo from './FooterLinksTwo';
// import FooterNewsletter from './FooterNewsletter';
import ToTop from './ToTop';
import FooterVegezat from './FooterVegezat';
import Chatbox from '../../chatbot_demo/chatbox';
// import FooterVegezat from './FooterVegezat';

function Footer(props) {
    const getCurrentYear = () => {
        return new Date().getFullYear();
    };
    const { locale, location } = props;

    let logo;

    if (locale === 'sq') {
        logo = (
            <div className="site-footer__logo">
                <Link to="/"><img src="/images/logot/arbk_shq.png" alt="" /></Link>
            </div>
        );
    } else if (locale === 'en') {
        logo = (
            <div className="site-footer__logo">
                <Link to="/"><img src="/images/logot/arbk_en.png" alt="" /></Link>
            </div>
        );
    } else if (locale === 'sr') {
        logo = (
            <div className="site-footer__logo">
                <Link to="/"><img src="/images/logot/arbk_sr.png" alt="" /></Link>
            </div>
        );
    }

    return (
        <div className={`site-footer footer--${location}`}>
            <div className="footer">
                <div className="site-footer__widgets">
                    <div className="row footer-row">
                        <div className="footer-img-box">
                            <div className="logo-footer-grid">
                                {logo}
                                <div className="">
                                    <div className="footer-links-box">
                                        <FooterContacts />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-nav">
                            <div className="links-ft">
                                <div className="footer-links-box">
                                    <FooterLinks layout="footerone" />
                                </div>
                            </div>
                            <div className="links-ft">
                                <div className="footer-links-box">
                                    <FooterLinks layout="footertwo" />
                                </div>
                            </div>
                            <div className="links-ft">
                                <div className="footer-links-box">
                                    <FooterLinks layout="footerthree" />
                                </div>
                            </div>
                            <div className="links-ft">
                                <div className="footer-links-box">
                                    <FooterVegezat />
                                </div>
                            </div>
                            {/* <div className="links-ft">
                                <div className="footer-links-box">
                                    <Link to="/Home" className="linksTitles">LEGJISLACIONI</Link>
                                    <FooterVegezat />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="site-footer__bottom">

                <div className="container">
                    <div className="footer__bottom">
                        <div className="site-footer__copyright">
                            Copyright ©
                            {' '}
                            {getCurrentYear()}
                            {'. '}
                            <FormattedMessage id="Copyrights" defaultMessage="Copyrights" />
                            {' '}
                        </div>
                    </div>
                </div>
            </div>
            <div className="sticky-button">
                <ToTop />
                <Chatbox />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(Footer);
